/**
 *
 * Footer
 *
 */

import React from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

import styled from 'styled-components';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Col, Container, Row, NavItem, NavLink, Nav } from 'reactstrap';
import messages from './footerMessages';

const FooterDiv = styled.div`
  background-color: rgb(7, 17, 32);
`;

const PaddedContainer = styled(Container)`
  height: 40px;
  padding: 10px;
  font-family: 'Manrope', sans-serif;
`;

export const Footer = injectIntl(({ intl }) => (
  <div className="tpicap-footer">
    <FooterDiv className="p-4">
      <Container>
        <Row>
          <Col>
            <Nav className="flex-column">
              <NavItem>
                <NavLink href="/Parameta Solutions - TCA - Privacy Notice.pdf">
                  <FormattedMessage {...messages.privacyLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/Parameta Solutions - TCA - Cookie Notice.pdf">
                  <FormattedMessage {...messages.cookieLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://parametasolutions.com/sitemap">
                  <FormattedMessage {...messages.siteMapLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://tpicap.com/tpicap/accessibility">
                  <FormattedMessage {...messages.accessibilityLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://parametasolutions.com/rss-feeds">
                  <FormattedMessage {...messages.rssFeedLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href={`mailto:${intl.formatMessage(
                    messages.contactUsMessage,
                  )}`}
                >
                  <FormattedMessage {...messages.contactUsLink} />
                </NavLink>
              </NavItem>
            </Nav>
          </Col>

          <Col>
            <Nav className="flex-column">
              <NavItem>
                <NavLink href="/Parameta Solutions - TCA - Disclaimer.pdf">
                  <FormattedMessage {...messages.disclaimerLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://tpicap.com/tpicap/responsibility/our-commitments/modern-slavery-and-human-trafficking-statement">
                  <FormattedMessage {...messages.slaveryStatementLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="http://tpicap.com/legal-and-regulatory/memberships">
                  <FormattedMessage {...messages.membershipsLink} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://tpicap.com/tpicap/home/legal-and-regulatory">
                  <FormattedMessage {...messages.legalRegHeader} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://tpicap.com/tpicap/brexit-information">
                  <FormattedMessage {...messages.brexit} />
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://tpicap.com/tpicap/home/Occupational%20Pension%20Schemes%20%28Administration%20and%20Disclosure%29%20Regulations%202018">
                  <FormattedMessage {...messages.pension} />
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
      </Container>
    </FooterDiv>
    <div>
      <PaddedContainer>
        <FormattedMessage {...messages.copyright} />
      </PaddedContainer>
    </div>
  </div>
));
